<template>
  <div class="mod-user-status">
    <h4 class="title">{{ title }}</h4>
    <div v-if="status === 6 && message" class="message">
      <p v-for="(item, idx) in statusMessage" :key="idx">{{ item }}</p>
    </div>
    <div class="options">
      <router-link v-if="status === -10" class="button" to="/login">开始登录</router-link>
      <router-link v-else class="button" to="/">返回纵购商城首页</router-link>
      <button v-if="status === 0" class="button next" @click="goto('/')">进入店铺管理中心</button>
      <button v-if="status === 6" class="button next" to="/join" @click="gotoStep2">
        完善申请资料
      </button>
    </div>
  </div>
</template>

<script>
import { syncToken, getAccessToken, getUser, setUser } from '@/utils'
import { getSeller } from '@/data'

export default {
  name: 'ModUserStatus',
  props: {
    status: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    }
  },
  computed: {
    statusMessage() {
      return this.message.split(/\n|\r|\r\n/)
    }
  },
  methods: {
    async goto(baseUrl) {
      const token = getAccessToken()

      if (!token) {
        syncToken()
        this.$router.push('/login')
        return
      }

      const { show_welcome } = await getSeller(0)
      setUser({ ...getUser(), show_welcome })

      window.location.href = `${process.env.VUE_APP_SELLER_ORIGIN}${baseUrl}`
    },
    gotoStep2() {
      this.$emit('update:status', 2)
    }
  }
}
</script>

<style lang="postcss">
.mod-user-status {
  background-color: #fff;
  text-align: center;
  height: 520px;
  padding: 148px 0;

  .title {
    font-weight: normal;
    color: #666;
    font-size: 28px;
  }

  .message {
    width: 420px;
    background-color: #ffffe8;
    border: 1px solid #e4e4e4;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.2);
    font-size: 12px;
    color: #f00;
    line-height: 16px;
    margin: 20px auto 0 auto;
    padding: 20px;
    text-align: left;
  }

  .options {
    margin-top: 70px;

    .button {
      background-color: #ffd600;
      font-size: 18px;
      line-height: 50px;
      height: 50px;
      width: 260px;
      display: inline-block;
      border-radius: 5px;
      border: none;
      margin: 50px 15px 0 15px;

      &.next {
        background-color: #2d8cf0;
        color: #fff;
      }
    }
  }
}
</style>
